import styled from "styled-components";
import Icon from "app/components/shared/Icon";

type Props = {
  failures: number;
  passes: number;
};

const Container = styled.div`
  display: grid;
  grid-gap: 13px;
  grid-template-columns: auto auto;

  > span {
    display: flex;
    align-items: center;
  }
`;

const ResultIcon = styled(Icon)`
  fill: none !important;
  height: 14px;
  width: 14px;
  color: ${(props) => props.$colour || "var(--base-1000)"};
  margin-right: 5px;
`;

const ResultCount = (props: Props) => (
  <Container>
    <span>
      <ResultIcon
        icon="cross-tiny"
        title={`${props.failures} failed`}
        $colour="var(--red-500)"
      />
      {props.failures}
    </span>
    <span>
      <ResultIcon
        icon="check-tiny"
        title={`${props.passes} passed`}
        $colour="var(--green-500)"
      />
      {props.passes}
    </span>
  </Container>
);

export default ResultCount;
